import React from 'react';
import { Bell, Settings, LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { OrgSwitcher } from '../OrgSwitcher';
import pic from '../../assets/images/pic.png';
import logo from '../../assets/images/logo.svg';

interface HeaderProps {
  userName?: string;
  userAvatar?: string;
  onLogout?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  userName = 'John Carter',
  userAvatar: _userAvatar,
  onLogout,
}) => {
  return (
    <header className="bg-background border-b border-border sticky top-0 z-50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Left Section (Logo & Org Switcher) */}
        <div className="flex items-center gap-3">
          <img src={logo} alt="ZuroQ Logo" className="h-12 w-auto" />
          <OrgSwitcher />
        </div>

        {/* Right Section (Actions & User Profile) */}
        <div className="flex items-center gap-4">
          {/* Notifications Button */}
          <Button variant={'ghost'} size={'icon'} className="h-10 w-10">
            <Bell className="h-5 w-5" />
          </Button>

          {/* User Profile Dropdown */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant={'ghost'}
                className="h-auto w-auto px-3 py-1.5 flex items-center gap-3"
              >
                <div className="hidden sm:flex flex-col items-end">
                  <span className="font-medium text-sm">{userName}</span>
                  <span className="text-xs text-muted-foreground">ZUROQ</span>
                </div>
                <Avatar className="h-9 w-9">
                  <AvatarImage src={pic} alt="User avatar" />
                  <AvatarFallback className="bg-muted text-muted-foreground text-xs">
                    40x40
                  </AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <div className="flex flex-col space-y-1">
                  <p className="text-sm font-medium leading-none">{userName}</p>
                  <p className="text-xs leading-none text-muted-foreground">ZUROQ</p>
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <Settings className="h-4 w-4 mr-2" />
                Paramètres
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onLogout}>
                <LogOut className="h-4 w-4 mr-2" />
                Déconnexion
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};
